<template>
  <div class="saomaBycard">
    <h1>扫码全覆盖，方便你我他</h1>
    <video controls class="video">
      <source src="../assets/movie.mp4" type="video/mp4" />
    </video>
    <div>
      2018年6月，市民卡公司联合公交集团推出基于昆山山市民综合服务平台的“扫码乘车”功能，就此昆山公交正式从“卡时代迈入“码”时代，实现使用手机扫码支付。首批1路、8路2条公交线路上线试运营后，“扫码乘车”功能得到了市民的一致好评和认可。通过多月的努力，目前已实现全市范围内所有公交线路支持“扫码乘车”功能<br />
      <p>
        市民只需在手机应用市场下载、安装鹿路通”APP，实名注册“扫码乘车”并成功充值后，就可以使用扫码支付功能。将生成的二维码对准车载POS机的扫码区，听到“刷码成功”的语音播报后，即完成支付。一票制公交线路只需上车一次扫码，多票制线路需上、下车两次扫码，系统将根据上、下车站点的距离自动扣费，享受普通成人卡同等的6折优惠。
      </p>
      <p>
        随着昆山公交扫码支付功能全面覆盖带给广大市民更加安全、便捷、高效的出行体验同时，也引领昆山交通出行进入绿色低碳的“码”上时代。
      </p>

      <br />
    </div>
  </div>
</template>

<script>
export default {
  mounted() {},
};
</script>

<style lang="scss" scoped>
.saomaBycard {
  padding: 2.5rem 2rem;
  min-height: 100vh;
  background-color: #ffff;
  h1 {
    font-size: 2.5rem;
  }
  div {
    font-size: 2rem;
    margin-top: 2.5rem;
    text-indent: 20px;
  }
}
.video {
  margin-top: 2.5rem;
  width: 100%;
}
</style>